export default __webpack_public_path__ + "static/media/exclamation.cc8c98b6.svg";